import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { ContactsListProps } from "../model";
import { ContactsListDesktop, ContactsListMobile } from "./components";

export const ContactsList = ({
  contacts,
  selectedPersonId,
  setSelectedPersonId,
}: ContactsListProps) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <ContactsListDesktop
          contacts={contacts}
          selectedPersonId={selectedPersonId}
          setSelectedPersonId={setSelectedPersonId}
        />
      }
      mobile={<ContactsListMobile />}
    />
  );
};
